/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { APP_INITIALIZER, Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { OSKLocaleService } from '../../services/locale.service';

function localeInitializerFactory(translate: TranslateService, localeService: OSKLocaleService) {
  return (): Promise<unknown> => {
    localeService.initialize();
    return firstValueFrom(translate.use(localeService.locale()));
  };
}

export const OSKLocaleInitializer: Provider = {
  provide: APP_INITIALIZER,
  useFactory: localeInitializerFactory,
  deps: [TranslateService, OSKLocaleService],
  multi: true
};
